import { EntityStatusDesc } from '../../../models/entity.model'
import { ExecutionStatus, ExecutionType } from '../models/execution.types'

export const EXECUTION_STATUSES: EntityStatusDesc<ExecutionStatus>[] = [
  {
    code: 'COMPLETED',
    name: 'Completed',
  },
  {
    code: 'FAILED',
    name: 'Failed',
  },
  {
    code: 'PENDING',
    name: 'Pending',
  },
  {
    code: 'RUNNING',
    name: 'Running',
  },
  {
    code: 'UNKNOWN',
    name: 'No reply',
  },
]

export const EXECUTION_TYPES: EntityStatusDesc<ExecutionType>[] = [
  {
    code: 'MANUAL',
    name: 'Manual',
  },
  {
    code: 'SCHEDULED',
    name: 'Scheduled',
  },
  {
    code: 'INTERNAL',
    name: 'One-off',
  },
]
